import React, { useState, useRef, useEffect, useContext } from 'react';
import { FaFire } from 'react-icons/fa';
import CategoryModal from '../elements/CategoryModal';
import { BsArrowUpCircle, BsInfoCircle } from 'react-icons/bs';
import { MdOutlineRemoveShoppingCart } from 'react-icons/md';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Header from '../components/Header';

export default function Menu({ restaurant,  }) {
  const [categoryModalVisible, setCategoryModalVisible] = useState(false);
  const [activeCategory, setActiveCategory] = useState(0);
  const [modal, setModal] = useState(false);
  const [item, setItem] = useState(null);
  const availableFlags = [
    { id: 'mild', name: 'Mild (Spicy)', icon: '🌶️' },
    { id: 'hot', name: 'Medium (Spicy)', icon: '🌶️🌶️' },
    { id: 'extrahot', name: 'Hot (Spicy)', icon: '🌶️🌶️🌶️' },
    { id: 'raw', name: 'Raw', icon: '🐟' },
    { id: 'nut_free', name: 'Nut Free', icon: '🥜' },
    { id: 'gluten_free', name: 'Gluten Free', icon: '🫓' },
    { id: 'dairy_free', name: 'Dairy Free', icon: '🥛' },
    { id: 'vegan', name: 'Vegan', icon: '🌿' },
    { id: 'vegetarian', name: 'Vegetarian', icon: '🥦' },
    { id: 'halal', name: 'Halal', icon: '🕌' },
  ];

  const handleCategoryClick = (categoryId) => {
    setActiveCategory(categoryId);
    setCategoryModalVisible(false);
    const categoryOffset = getCategoryOffset(categoryId);
    if (categoryOffset) {
      window.scrollTo({ top: categoryOffset, behavior: 'smooth' });
    }
  };

  const getCategoryOffset = (categoryId) => {
    const categoryElement = document.getElementById(`category-${categoryId}`);
    if (categoryElement) {
      const rect = categoryElement.getBoundingClientRect();
      return rect.top + window.scrollY - 200;
    }
    return 0;
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 250;
      restaurant?.Categories.forEach((category, index) => {
        const categoryElement = document.getElementById(`category-${index}`);
        if (categoryElement) {
          const offsetTop = categoryElement.offsetTop;
          const offsetHeight = categoryElement.offsetHeight;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveCategory(index);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [restaurant]);

  return (
    <>
          <Header />

    <div>
      <div className="container my-5">
        <div className="text-center mb-5">
          <p className=" fw-bold" style={{ marginTop: '100px' }}>Our Menu</p>
        </div>

        {restaurant?.Categories.map((category, index) => (
          <div key={category.id} className="mb-5" id={`category-${index}`}> 
            <h3 className="text-center  fw-bold mb-4">{category.name}</h3>
            <div className="row">
              {category.Items.map((itm) => (
                <div className="col-md-3 col-6 mb-4 d-flex" key={itm.id}>
                  <div className="card w-100 h-100 border-0 shadow-sm d-flex flex-column" onClick={() => { setItem(itm); setModal(true); }}>
                    <div className="position-relative" style={{ aspectRatio: '4 / 3', overflow: 'hidden' }}>
                      <img
                        src={itm.image_url || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScO99JkPvdfSyT3CbMrYsKBpRuXOACVR2cP9F6DBcP9B6nQ9oszX_18T-2oNv6Gyxwyhk&usqp=CAU'}
                        alt={itm.name}
                        className="w-100 h-100 object-fit-cover"
                      />
                      {itm.hot_item && (
                        <div className="position-absolute top-0 start-0 bg-danger text-white small fw-bold px-2 py-1 rounded shadow d-flex align-items-center gap-1 m-2">
                          <FaFire className="text-warning" />
                          Popular
                        </div>
                      )}
                      {Array.isArray(itm.flags) && itm.flags.length > 0 && (
                        <div className="position-absolute top-0 end-0 bg-white text-dark small fw-semibold px-2 py-1 rounded shadow d-flex align-items-center gap-1 m-2">
                          <span>{availableFlags.find(f => f.id === itm.flags[0])?.icon || '🏷️'}</span>
                          <span className="d-none d-sm-inline">{availableFlags.find(f => f.id === itm.flags[0])?.name || itm.flags[0]}</span>
                        </div>
                      )}
                      {itm.sold_out && (
                        <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center">
                          <MdOutlineRemoveShoppingCart className="text-white me-2" size={24} />
                          <span className="text-white fw-bold text-uppercase small user-select-none">Sold Out</span>
                        </div>
                      )}
                    </div>
                    <div className=" text-center d-flex flex-column justify-content-between">
                      <h5 className="fw-bold  ">{itm?.name}</h5>
                      <div className="fw-bold text-dark">{itm?.market_price ? 'Market Price' : <>${itm.price}</>}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

        <CategoryModal show={categoryModalVisible} onClose={() => setCategoryModalVisible(false)}>
          <div className="p-3">
            {restaurant?.Categories.map((category, index) => (
              <div
                key={category.id}
                className={`p-2 rounded text-center fw-medium mb-2 ${activeCategory === index ? 'bg-primary text-white' : 'bg-light text-dark'}`}
                onClick={() => handleCategoryClick(index)}
                style={{ cursor: 'pointer' }}
              >
                {category.name}
              </div>
            ))}
          </div>
        </CategoryModal>
      </div>

      <button
        onClick={() => setCategoryModalVisible(true)}
        className="btn w-100 position-fixed bottom-0 start-0 rounded-top fw-semibold d-flex justify-content-center align-items-center gap-2 py-3 shadow"
        style={{ backgroundColor: 'red', color: 'white', zIndex: 1000 }}
      >
        {restaurant?.Categories[activeCategory]?.name || 'Categories'}
        <BsArrowUpCircle className="ms-2" />
      </button>

      <Modal show={modal} onHide={() => setModal(false)} centered scrollable size="lg">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="w-100 text-center text-dark fw-bold">
            {item?.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-2">
          {item?.image_url && (
            <div className="mb-3 position-relative rounded overflow-hidden">
              <img src={item.image_url} alt={item?.name} className="w-100 rounded"  style={{height:'250px'}}/>
              {item.hot_item && (
                <div className="position-absolute top-0 end-0 bg-danger text-white small px-2 py-1 rounded m-2 d-flex align-items-center">
                  <FaFire className="text-warning me-1" /> Popular
                </div>
              )}
              {item?.price && (
                <div className="position-absolute bottom-0 end-0 bg-white bg-opacity-75 text-dark small fw-semibold px-3 py-1 rounded m-2 d-flex align-items-center">
                  {item.market_price ? (
                    <>
                      <span className="me-2">Market Price</span>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-marketprice">Market Price means the price varies daily based on current seafood or ingredient costs.</Tooltip>}
                      >
                        <BsInfoCircle className="text-info" style={{ cursor: 'pointer' }} />
                      </OverlayTrigger>
                    </>
                  ) : (
                    <span>${item.price}</span>
                  )}
                </div>
              )}
            </div>
          )}

          {Array.isArray(item?.flags) && item?.flags.length > 0 && (
            <div className="mb-3 d-flex flex-wrap gap-2">
              {availableFlags.filter(flag => item.flags.includes(flag.id)).map(flag => (
                <span key={flag.id} className="badge bg-light border text-dark d-flex align-items-center gap-1">
                  <span>{flag.icon}</span>
                  <span>{flag.name}</span>
                </span>
              ))}
            </div>
          )}

          {item?.description && item.description !== 'null' && (
            <p className="text-muted border-bottom pb-2">{item.description}</p>
          )}

          {item?.Restaurant_Item_Attributes?.length > 0 && (
            <div className="mt-3">
              <h6 className="fw-semibold text-dark mb-2">Options Available</h6>
              {item.Restaurant_Item_Attributes.map(attr => (
                <div key={attr.id} className="mb-3">
                  <div className="fw-medium small mb-1">-{attr?.Item_Attribute?.name}</div>
                  <div className="d-flex flex-wrap gap-2">
                    {attr.Item_Attribute.Item_Attribute_Options?.map(option => (
                      <span
                        key={option.id}
                        className="badge bg-light border text-dark d-flex align-items-center gap-1"
                      >
                        {option.name}
                        {option.price_modifier > 0 && (
                          <span className="text-secondary small">+${option.price_modifier}</span>
                        )}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
    </>
  );
}
